import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './mirin-verify-support.component.html',
  styleUrls: ['./mirin-verify-support.component.scss']
})
export class MirinVerifySupportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
